import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'EO',
  templateUrl: './engineOil.component.html',  
})

 export class EngineComponent {
 public prjId:any
 public userId:any
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
     
  }

}
 


// WEBPACK FOOTER //
// ./src/app/maintenance/EngineOil/engineOil.component.ts